<template>
  <div class="developer-projects-lead">
    <intersect @enter="animate4 = true">
      <div class="overview-left fadeUp" :class="animate4 ? 'animate' : ''">
        <div class="form-container br-12" :class="hideImg ? 'next-step' : ''">
          <div class="img-box">
            <!-- <picture>
              <source
                media="(max-width: 767px)"
                :srcset="
                  _.get(
                    $store.state.current_content,
                    'primary.0.images.0.devices.mobile'
                  )
                "
              />
              <source
                media="(max-width: 1023px)"
                :srcset="
                  _.get(
                    $store.state.current_content,
                    'primary.0.images.0.devices.tablet'
                  )
                "
              />
              <img
                :src="
                  _.get(
                    $store.state.current_content,
                    'primary.0.images.0.devices.desktop'
                  )
                "
                class="img-absolute br-12"
                alt
              />
            </picture> -->
            <img src="@/assets/img/LeadImage.png" class="img-absolute br-12" />
            <div class="gradient br-12"></div>
            <div class="form-banner-content">
              <h4 class="font-34 noto-semibold white">
                {{_.get( $store.state.current_content, 'primary.0.form_title' )}}
              </h4>
  <!--                  <p class="text white">{{ $fn.tr("Find some tips") }}</p>-->
              <div class="enter btn sub bg-white" id="enterBtn" v-on:click="hideImg = !hideImg">
                {{ $fn.tr("Enter") }}
              </div>
            </div>
          </div>

          <h3 class="other-title">{{_.get( $store.state.current_content, 'primary.0.form_title' )}}</h3>

          <el-form
            v-if="formStatus=='show-form'"
            action
            class="member-form flex-box column"
            :model="ruleForm"
            :rules="rules"
            ref="ruleForm"
          >
            <el-form-item
              for="name"
              class="flex-box column font-12 noto-semibold"
              prop="name"
            >
              {{ $fn.tr("სახელი, გვარი") }}
              <el-input
                type="text"
                name="name"
                :placeholder="$fn.tr('სახელი, გვარი')"
                v-model="ruleForm.name"
              ></el-input>
            </el-form-item>

            <el-form-item
              for="phone"
              class="flex-box column font-12 noto-semibold"
              prop="phone"
            >
              {{ $fn.tr("მობილურის ნომერი") }}
              <el-input
                type="number"
                name="phone"
                :placeholder="$fn.tr('მობილურის ნომერი')"
                v-model="ruleForm.phone"
              ></el-input>
            </el-form-item>
<!-- 
            <el-form-item
              class="flex-box column font-12 noto-semibold"
              style="z-index: 3;"
            >
                {{ $fn.tr("აირჩიეთ სერვისცენტრი") }}
                <CustomSelect :options="branchList" v-model="selectedBranch" :placeholderText="$fn.tr('აირჩიეთ სერვისცენტრი')" />
                <div class="error-msg noto-semibold font-12" v-if="errors.branch">
                  {{ $fn.tr("აირჩიე სერვისცენტრი") }}
                </div>
            </el-form-item>

            <el-form-item
              class="flex-box column font-12 noto-semibold"
              style="z-index: 2;"
            >
                {{ $fn.tr("აირჩიეთ ქალაქი") }}
                <CustomSelect :options="cityList" v-model="selectedCity" :placeholderText="$fn.tr('აირჩიეთ ქალაქი')" />
                <div class="error-msg noto-semibold font-12" v-if="errors.city">
                  {{ $fn.tr("აირჩიე ქალაქი") }}
                </div>
            </el-form-item> -->

            <el-form-item
              class="flex-box column font-12 noto-semibold"
              style="z-index: 1;"
              v-if="selectedCity && regionList.filter(x => x.pid == selectedCity).length"
            >
                {{ $fn.tr("აირჩიეთ უბანი") }}
                <CustomSelect :options="regionList.filter(x => x.pid == selectedCity)" v-model="selectedRegion" :placeholderText="$fn.tr('აირჩიეთ უბანი')" />
                <div class="error-msg noto-semibold font-12" v-if="errors.region">
                  {{ $fn.tr("აირჩიე უბანი") }}
                </div>
            </el-form-item>

            <!-- <div class="form-end flex-box">
              <div class="captcha">
                <vue-recaptcha
                    :sitekey="_.get($store.state.indx, 'nocapcha.sitekey')"
                    :loadRecaptchaScript="true"
                    @verify="onVerify"
                ></vue-recaptcha>
              </div>
            </div> -->

            <div class="form-end flex-box">
              <el-button class="btn sub white ml-0" type="primary" @click="submitForm()" >{{ $fn.tr("Send") }}</el-button>
            </div>
          </el-form>

          <div class="success-msg br-12" v-show="formStatus=='show-thank-text'">
            <h5 class="noto-bold font-34">{{ $fn.tr("Thank you!") }}</h5>

            <p class="text">
              {{_.get( $store.state.current_content, 'primary.0.thanks_text' )}}
            </p>

            <button class="reset-btn btn white" @click="resetForm">{{ $fn.tr("Reset") }}</button>
          </div>
        </div>
      </div>
    </intersect>
  </div>
</template>

<script>
import Intersect from "vue-intersect";
import VueRecaptcha from "vue-recaptcha";
import CustomSelect from "@/components/CustomSelect";
// import { required, minLength, maxLength, numeric, email } from 'vuelidate/lib/validators'

export default {
  components: {
    Intersect,
    VueRecaptcha,
    CustomSelect,

  },
  data() {
    return {
      formStatus: 'show-form',
      animate: false,
      animate2: false,
      animate3: false,
      animate4: false,
      animate5: false,
      animate6: false,
      hideImg: false,
      ruleForm: {
        name: "",
        phone: "",
      },
      rules: {
        name: [
          {
            required: true,
            message: this.$fn.tr("მიუთითე სახელი, გვარი"),
            trigger: "blur",
          },
        ],
        phone: [
          {
            required: true,
            message: this.$fn.tr("მიუთითე ნომერი"),
            trigger: "blur",
          },
        ],
      },
      errors: {
        branch: false,
        city: false,
        region: false,
      },
      selectedBranch: 0,
      // branchList: [
      //   {
      //       title: "თბილისი, გ. ჭანტურიას ქ. #14",
      //       id: "0",
      //   },
      //   {
      //       title: "თბილისი, ი. ჭავჭავაძის გამზ. #2",
      //       id: "1",
      //   },
      //   {
      //       title: "თბილისი, ვაჟა-ფშაველას გამზ. #21",
      //       id: "2",
      //   },
      //   {
      //       title: "თბილისი, პეკინის გამზ. #24ა",
      //       id: "3",
      //   },
      //   {
      //       title: "თბილისი, ა. წერეთლის გამზ. #67",
      //       id: "4",
      //   },
      //   {
      //       title: "თბილისი, გლდანი, ხიზანიშვილის ქ. #3",
      //       id: "5",
      //   },
      //   {
      //       title: "თბილისი, ვარკეთილის ბიზნესცენტრი",
      //       id: "6",
      //   },
      //   {
      //       title: "ბათუმი, ფარნავაზ მეფის ქ. #55",
      //       id: "7",
      //   },
      //   {
      //       title: "ზუგდიდი, ზ. გამსახურდიას ქ. #31",
      //       id: "8",
      //   },
      //   {
      //       title: "ქუთაისი, რუსთაველის ქ. #5",
      //       id: "9",
      //   },
      // ],
      selectedCity: 0,
      cityList: [],
      selectedRegion: 0,
      regionList: [],
    };
  },
  methods:{
    async sendForm(payload) {
      await this.$fn.postData("main/saveLeadForm", payload);

      this.formStatus = 'show-thank-text';
    },
    async submitForm(){
      // if (!this.selectedBranch) {
      //   this.errors.branch = true;
      // } else {
      //   this.errors.branch = false;
      // }

      // if (!this.selectedCity) {
      //   this.errors.city = true;
      // } else {
      //   this.errors.city = false;
      // }

      // if (!this.selectedRegion) {
      //   this.errors.region = true;
      // } else {
      //   this.errors.region = false;
      // }

      this.$refs.ruleForm.validate((valid) => {
        // && this.selectedBranch && this.selectedCity && (this.regionList.filter(x => x.pid == this.selectedCity).length ? this.selectedRegion : true)
        if (valid) {
          let req = {
            formData: {
              ...this.ruleForm,
              // branch: this.branchList.find(x => x.id == this.selectedBranch).title,
              // city: this.cityList.find(x => x.id == this.selectedCity).title,
              // region: this.selectedRegion ? this.regionList.find(x => x.id == this.selectedRegion).title : null,
            },
            formType: "partner-developers",
          };

          this.sendForm(req);
        } else {
          return false;
        }
      });
    },
    resetForm(formName) {
      this.ruleForm = {};
      this.formStatus = 'show-form';
      this.selectedBranch = 0;
      this.selectedCity = 0;
      this.selectedRegion = 0;
    },
    onVerify(e) {
      console.log(e);
    },
    setTaxonomyItems() {
      _.get(this.$store.state.indx, 'terms.developers_location').forEach(loc => {
        if (loc.pid) {
          this.regionList.push(loc);
        } else {
          this.cityList.push(loc);
        }
      });
    },
  },
  computed: {
    branchList() {
      return this.$store.state.indx.branches.map((branch, index) => ({ ...branch, title: branch.Address, id: String(index) }))
    },
  },
  mounted() {
    this.setTaxonomyItems();
  },
};
</script>

<style>
.ml-0{ margin-left: 0 !important; }
.form-container .el-form-item.is-error .el-input__inner,
.form-container .el-form-item.is-error .el-input__inner:focus,
.form-container .el-form-item.is-error .el-textarea__inner,
.form-container .el-form-item.is-error .el-textarea__inner:focus,
.form-container .el-message-box__input input.invalid,
.form-container .el-message-box__input input.invalid:focus {
  border-color: #d0aa67;
}
.form-container .el-form-item__error {
  color: #d0aa67;
  font-family: "NotoSansGeorgian-SemiBold", "NotoSans-SemiBold";
  padding-top: 5px;
  position: relative;
  transition: 0.4s;
}
.el-input.is-active .el-input__inner,
.el-input__inner:focus,
.el-textarea__inner:focus {
  border-color: #d0aa67;
}
.form-container .el-form-item__content {
  font-size: 12px;
  font-family: "NotoSansGeorgian-SemiBold", "NotoSans-SemiBold";
  line-height: 17px;
  margin-bottom: 18px;
}
.form-container .el-form-item {
  margin-bottom: 0;
}
.el-button--primary:focus,
.el-button--primary:hover,
.el-button--primary.is-active,
.el-button--primary:active,
.el-button--primary {
  border-color: transparent;
}

.unique-overview .overview-right h3 {
  font-size: 34px;
  font-family: "NotoSansGeorgian-SemiBold", "NotoSans-SemiBold";
  line-height: 40px;
}
.form-container .success-msg {
  opacity: 1;
  pointer-events: all;
}
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
	-moz-appearance: none;
  margin: 0;
}
@media (max-width: 767px) {
  .unique-overview .overview-right h3 {
    font-size: 21px;
  }
}

.developer-projects-lead .overview-left {
  width: auto;
}

.developer-projects-lead .form-container {
  overflow: visible;
}

.developer-projects-lead .img-box {
  /* padding-top: 123%; */
  padding-top: 77%;
  z-index: 5;
}

.developer-projects-lead .custom-select {
  background-color: #eeece8;
}

@media (max-width: 1600px) {
  .developer-projects-lead .img-box {
    padding-top: 100%;
  }
}

@media (max-width: 1023px) {
  .developer-projects-lead .img-box {
    padding-top: 0;
  }
}
</style>